<app-data-grid
  #grid
  [viewId]="viewId"
  [title]="title"
  [icon]="icon"
  gridClassName="user-list-grid"
  [columnDefs]="columnDefs"
  [fetchRows]="fetchRows"
  [csvServerSide]="true"
  [onExportCsvServerSide]="exportCsvServerSide"
  routedEditorObjectName="user"
>
  <ng-container toolbarActions>
    <sui-button
      variant="primary"
      [leadingIcon]="['fas', 'plus']"
      gridToolbarAction
      [label]="'user-list.button.create-user' | translate"
      (click)="createUser()"
    ></sui-button>
    <sui-button
      variant="primary"
      [leadingIcon]="['fas', 'file-import']"
      gridToolbarAction
      [label]="'user-list.button.import-users' | translate"
      (click)="importUsers()"
    ></sui-button>
  </ng-container>
</app-data-grid>
